/** The till: header, scan bar, item grid, the bill, function buttons and the till's messages. */
export default {
  // till header
  'till.shiftOpen': 'Shift open',
  'till.noShift': 'No shift open',
  'till.shiftUnknown': 'Shift unknown',
  'till.checkingShift': 'Checking shift…',
  'till.heldBills': 'Held bills',
  'till.openShift': 'Open shift',
  'till.closeShift': 'Close shift',
  'till.customerScreen': 'Customer screen',
  'till.language': 'Language',
  'till.items': 'Items',
  'till.bill': 'Bill',
  'till.offline': 'OFFLINE',
  'till.since': 'Since {time}',
  'till.counter': 'Counter {name}',
  'till.statsTitle': 'This shift so far',
  'till.statBills': { one: 'bill', other: 'bills' },
  'till.statSales': 'sales',
  'till.statAvg': 'avg bill',
  'till.displayTitle': 'Open the customer screen on a second monitor',
  'till.displayOpen': 'Open the customer screen',
  'till.help': 'Keyboard shortcuts',
  'till.helpTitle': 'Keyboard shortcuts (?)',
  'till.view': 'Till view',
  'till.scanSection': 'Scan and quick keys',
  'till.scanCamera': 'Scan with camera',
  'till.camera': 'Camera',
  'till.noShiftBanner': 'No shift is open. Count the float into the drawer and open a shift to start billing.',
  'till.configFailed': 'Could not load the till settings, so the total and the round-off cannot be trusted yet.',
  'till.shiftCheckFailed': 'Could not check this register’s shift. Billing still works; retry to find out whether a drawer is already open.',
  'till.mobileQty': 'qty {qty}',
  'till.store': 'Store',
  'till.ourStore': 'our store',

  // till messages
  'pos.shiftOpened': 'Shift open. You can start billing.',
  'pos.noBatch': '{name} has no batch in stock.',
  'pos.batch': 'batch',
  'pos.batchNo': 'batch {batch}',
  'pos.expires': 'exp {date}',
  'pos.needShift': 'Open a shift before billing.',
  'pos.outOfStock': '{name} is out of stock.',
  'pos.noBarcode': 'No product carries barcode {code}.',
  'pos.needItem': 'Add at least one item before taking payment.',
  'pos.clearTitle': 'Clear this bill?',
  'pos.clearMessage': 'All items on the current bill will be removed. Use Hold if you want to come back to it.',
  'pos.clearConfirm': 'Clear bill',
  'pos.totalMismatch': 'Invoice {invoice} totals ₹{actual} but the screen said ₹{quoted}. Do not print it. Call a manager.',
  'pos.invoiceSaved': 'Invoice {invoice} saved.',
  'pos.noReceipt': 'No receipt to reprint yet on this terminal.',
  'pos.removed': 'Removed {name}',
  'pos.taxBack': 'Tax is back on this bill.',
  'pos.discountBeyond': '{percent}% is beyond the {limit}% bill discount limit. Ask a manager.',
  'pos.discountApplied': '{percent}% off the bill.',
  'pos.customerRemoved': 'Customer removed from the bill.',
  'pos.customerAttached': '{name} attached.',
  'pos.resolveElsewhere': 'Sign in using the original cashier and terminal to resolve this sale.',
  'pos.openItemAdded': '{name} added.',
  'pos.noTaxApplied': 'No Tax applied to this bill.',
  'pos.holdLabel': { one: 'Bill · {count} item', other: 'Bill · {count} items' },
  'pos.held': 'Bill held. Stock has not been touched.',
  'pos.resumeNeedsApi': 'Update the API before resuming held bills with this till. Your held bill is still saved.',
  'pos.resumeNoTaxTitle': 'This bill was held with No Tax',
  'pos.resumeNoTaxNotAllowed': 'You are not allowed to remove tax. Resume it with tax added back, or leave it held for a manager.',
  'pos.resumeNoTaxStoreOff': 'This store no longer allows No Tax. Resume it with tax added back, or leave it held.',
  'pos.resumeWithTax': 'Resume with tax',
  'pos.leaveHeld': 'Leave it held',
  'pos.resumed': 'Resumed {hold}.',
  'pos.shiftBalanced': 'Shift closed. Drawer balanced.',
  'pos.shiftShort': 'Shift closed. Drawer short by ₹{amount}.',
  'pos.shiftOver': 'Shift closed. Drawer over by ₹{amount}.',
  'pos.withdrawn': '{name} has been withdrawn from sale.',
  'pos.needsQty': '"{name}" needs a quantity greater than zero.',

  // the search palette's actions
  'palette.customer': 'Attach a customer',
  'palette.customerHint': 'By mobile number: visits, spend and savings on the bill',
  'palette.payDue': '₹{amount} due',
  'palette.addItemFirst': 'Add an item first',
  'palette.hold': 'Hold this bill',
  'palette.holdHint': 'Park it; stock is not touched',
  'palette.resume': 'Resume a held bill',
  'palette.waiting': '{count} waiting',
  'palette.noneWaiting': 'None waiting',
  'palette.discountHint': 'Within your discount limit',
  'palette.reprintNumbered': 'Reprint last receipt {invoice}',
  'palette.reprintHint': 'Asks for a reason; recorded in the audit log',
  'palette.newHint': 'Clear the screen for the next customer',
  'palette.displayHint': 'Mirrors this bill on a second monitor',
  'palette.closeHint': 'Count the drawer',
  'palette.on': '{label} (on)',

  // keyboard shortcut help
  'help.subtitle': 'Press ? any time on the till to see these',
  'help.caption': 'Till keyboard shortcuts',
  'help.key': 'Key',
  'help.action': 'Action',
  'help.find': 'Find anything: items, “2 kg tomato”, a mobile number, actions',
  'help.ctrlK': 'Find anything (same as {key}).',
  'help.enter': 'In the scan bar: add the scanned code, or search for typed words. In payment: complete the sale.',
  'help.esc': 'Close the open dialog.',
  'help.note': 'F-keys work from the scan bar. Other shortcuts are ignored while typing in a field, so a barcode scan can never trigger one.',
  'shortcut.productSearch': 'Product search',
  'shortcut.customer': 'Attach customer',
  'shortcut.quantity': 'Edit quantity',
  'shortcut.removeItem': 'Remove line',
  'shortcut.holdBill': 'Hold bill',
  'shortcut.discount': 'Apply discount',
  'shortcut.customerLookup': 'Customer lookup',
  'shortcut.resumeBill': 'Resume held bill',
  'shortcut.payment': 'Take payment',
  'shortcut.reprintReceipt': 'Reprint last receipt',
  'shortcut.newSale': 'New sale',

  // scan bar
  'scan.placeholder': 'Scan a barcode, or type a name, ₹ amount or mobile number',
  'scan.placeholderNoShift': 'Open a shift to start billing',
  'scan.add': 'Add',
  'scan.ready': 'Scanner ready',
  'scan.input': 'Barcode scanner input',

  // just added
  'added.title': 'Just added',
  'added.undo': 'Undo',
  'added.openItem': 'open item',
  'added.idleNoShift': 'Open a shift and the scanner is ready.',
  'added.idle': 'Ready for the next item. Scan it, tap a tile, or type its name.',
  'added.findsAnything': 'finds anything',
  'added.weighed': 'Weighed · {qty} {unit}',
  'added.left': '{qty} left on the shelf',
  'added.overShelf': 'more than the shelf shows',
  'added.qtyOf': 'Quantity of {name}',
  'added.oneLess': 'One less {name}',
  'added.oneMore': 'One more {name}',
  'added.undoTitle': 'Take back what that scan added',

  // the item grid
  'grid.find': 'Find',
  'grid.findTitle': 'Find an item, a customer or an action by typing',
  'grid.categories': 'Filter by category',
  'grid.all': 'All items',
  'grid.favourites': 'Favourites ({count})',
  'grid.unavailable': 'Quick keys unavailable',
  'grid.loading': 'Loading items',
  'grid.noFavourites': 'No favourites yet. Tap the ☆ on any item to pin it here.',
  'grid.empty': 'No items in stock in this category.',
  'grid.quickKeys': 'Quick keys',
  'grid.gst': 'GST {percent}%',
  'grid.opensWeighPad': 'opens the weigh pad',
  'grid.addItem': 'Add {name}, ₹{price} per {unit}',
  'grid.inBill': 'In bill · {qty}',
  'grid.outOfStock': 'Out of stock',
  'grid.low': 'Low · {qty}',
  'grid.left': '{qty} left',
  'grid.pin': 'Pin {name} to favourites',
  'grid.unpin': 'Remove {name} from favourites',
  'grid.count': { one: '{count} item', other: '{count} items' },
  'grid.loadFailed': 'Could not load the catalogue. Check the connection.',

  // search palette
  'find.title': 'Find anything',
  'find.placeholder': 'Item, “2 kg tomato”, “₹50 onion”, a mobile number, or an action',
  'find.label': 'Find an item, customer or action',
  'find.nothing': 'Nothing matched “{term}”.',
  'find.start': 'Start typing. Try “3 milk”, “₹50 onion” or a mobile number.',
  'find.addOrRun': 'add or run',
  'find.try': 'Try “3 milk”, “500 g onion”, “₹50 coriander”, “hold”',
  'find.group.Customer': 'Customer',
  'find.group.Barcode': 'Barcode',
  'find.group.Best match': 'Best match',
  'find.group.Products': 'Products',
  'find.group.Actions': 'Actions',
  'find.customerPhone': 'Customer with mobile {phone}',
  'find.customerHint': 'Find them, or save a new customer on this bill',
  'find.barcode': 'Look up barcode {code}',
  'find.outOfStock': 'out of stock',
  'find.left': '{qty} left',
  'find.add': 'Add {qty} {unit} {name}',
  'find.results': 'Results',
  'find.move': 'move',

  // the bill
  'cart.title': 'Current bill',
  'cart.lines': { one: '{count} line', other: '{count} lines' },
  'cart.newBill': 'New bill',
  'cart.empty': 'Scan an item to start the bill',
  'cart.emptyTitle': 'The bill is empty',
  'cart.emptyHint': 'Scan a barcode, tap an item, or type what the customer asks for.',
  'cart.addItems': 'Add items',
  'cart.itemsLabel': 'Items on the bill',
  'cart.totalsLabel': 'Bill totals',
  'cart.addCustomer': 'Add customer by mobile',
  'cart.subtotal': 'Subtotal',
  'cart.units': 'units',
  'cart.discountGiven': 'Discount given',
  'cart.taxRemoved': 'Tax removed (No Tax)',
  'cart.gstIncluded': 'GST included',
  'cart.igstIncluded': 'IGST included',
  'cart.roundOff': 'Round off',
  'cart.toPay': 'To pay',
  'cart.pay': 'Pay',
  'cart.discount': 'Discount',
  'cart.discountOn': 'Discount on',
  'cart.hold': 'Hold',
  'cart.noTax': 'NO TAX',
  'cart.justAdded': 'Just added',
  'cart.customerHint': 'their visits and savings',
  'cart.saves': '{name} saves ₹{amount}',
  'cart.theCustomer': 'The customer',
  'cart.savesBoth': ' · ₹{mrp} below MRP + ₹{discount} discount',
  'cart.savesMrp': ' against MRP',
  'cart.savesDiscount': ' in discounts',
  'cart.regular': 'Regular',
  'cart.firstVisit': 'First visit',
  'cart.visits': { one: '{count} visit', other: '{count} visits' },
  'cart.spent': '{amount} spent',
  'cart.lastHere': 'last here {when}',
  'cart.detach': 'Detach customer {name}',
  'cart.editLine': 'Edit rate or discount',
  'cart.aboveMrp': 'above MRP ₹{mrp}',
  'cart.mrpSaves': 'MRP ₹{mrp} · saves ₹{saves}',
  'cart.off': '{value} off',
  'cart.weighed': 'Weighed',
  'cart.decrease': 'Decrease quantity of {name}',
  'cart.quantity': 'Quantity for {name}',
  'cart.increase': 'Increase quantity of {name}',
  'cart.remove': 'Remove {name}',
  'cart.removeTitle': 'Remove this line',

  // function buttons (action labels)
  'fn.bar': 'Function buttons',
  'fn.pages': 'Button pages',
  'fn.page': 'Page {page}',
  'action.nav.find': 'Find anything',
  'action.customer.attach': 'Attach customer',
  'action.customer.lookup': 'Customer lookup',
  'action.customer.remove': 'Remove customer',
  'action.line.quantity': 'Edit quantity',
  'action.line.removeLast': 'Remove last line',
  'action.bill.hold': 'Hold bill',
  'action.bill.resume': 'Resume held bill',
  'action.bill.discount': 'Bill discount',
  'action.bill.discountPreset': '{percent} off bill',
  'action.payment.take': 'Take payment',
  'action.bill.reprint': 'Reprint last receipt',
  'action.bill.new': 'New bill',
  'action.bill.noTax': 'No Tax',
  'action.system.customerDisplay': 'Customer screen',
  'action.line.openItem': 'Open item',
  'action.line.itemTax': 'Item tax',
  'action.why.needsItems': 'Add an item first.',
  'action.why.needsShift': 'Open a shift first.',
  'action.why.noCustomer': 'No customer on this bill.',
  'action.why.finishFirst': 'Finish or hold this bill first.',
  'action.why.noneHeld': 'No bills are held.',
  'action.why.noPercent': 'This button has no percentage set.',
  'action.why.cannotPay': 'You are not allowed to take payments.',
  'action.why.noReceipt': 'No receipt printed yet on this till.',
  'action.why.managerTax': 'Only a manager can remove tax.',
  'action.why.managerOpenItem': 'Only a manager can add an open item.',
  'action.why.noTaxOn': 'No Tax is on for this bill.',
  'action.why.needsOpenItem': 'Add an open item first; Item Tax applies to open items.',
} as const;
